
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const Partners = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section with Image */}
      <div className="relative h-[300px] overflow-hidden">
        <img
          src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf"
          alt="Business professionals collaborating in a modern meeting room"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/50 flex items-center justify-center">
          <h1 className="text-4xl font-bold text-white">Partner Programs</h1>
        </div>
      </div>

      {/* Content Section */}
      <div className="max-w-4xl mx-auto px-4 py-16">
        <Card className="p-8 bg-white shadow-lg">
          <div className="prose prose-lg max-w-none">
            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Introduction</h2>
              <p className="text-gray-700">Welcome to the Dynamico Partners Program! We believe in the power of collaboration and are excited to offer you the opportunity to become a partner and sell our product.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Who Can Become a Partner?</h2>
              <p className="text-gray-700">Anyone! Whether you're an individual, a small business, or a large corporation, you're welcome to join our Partners Program. We believe in inclusivity and the power of diverse partnerships.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Benefits of Becoming a Partner</h2>
              <p className="text-gray-700">As a partner, you'll have the opportunity to sell our product and earn a 30% commission on each sale. But that's not all! You'll also get access to exclusive partner resources, training, and support to help you succeed.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">4. How to Become a Partner</h2>
              <p className="text-gray-700">Joining our Partners Program is easy. Simply fill out our online application form, and once approved, you'll receive a welcome package with all the information you need to start selling.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Our Commitment to Our Partners</h2>
              <p className="text-gray-700">At Dynamico, we value our partners and are committed to providing you with all the tools and support you need to succeed. We believe that your success is our success.</p>
            </section>
          </div>
        </Card>

        {/* Redirect Button Section */}
        <div className="text-center mt-12">
          <Link to="/request-demo">
            <Button size="lg" className="bg-primary hover:bg-primary/90 text-white">
              Start Your Digital Journey Today
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Partners;
